import axios from "../axios";

export async function signIn(email, password) {
  try {
    const body = {
      user: {
        email: email,
        password: password
      }
    };

    return await axios.post(`/users/sign_in`, body);
  } catch (error) {
    throw error;
  }
}
